// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5DabSMpg","loader":"_5D33EWqc","sendRequest":"_5DCB4xEN","reports-container":"_5D10xtiz"};